<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button (onClick)="onTagAdd()" size="small" label="Add Product Tag" icon="pi pi-plus"
      [disabled]="isReadOnly()"></p-button>
    <p-button *ngIf="tabViewIndex === 0" (onClick)="onConsolidateSelected()" size="small"
      label="Consolidate {{ selectedTagCount >= 2 ? selectedTagCount + ' Selected' : 'Selected' }} Tags"
      icon="pi pi-sitemap" [disabled]="!canConsolidate()" styleClass="ml-2"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
  </div>

  <p-tabView class="pt-3 grow w-full qb-tabview" [(activeIndex)]="tabViewIndex" (onChange)="onTabChange($event)">
    <p-tabPanel header="Tags => Product Types">
      <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
        <ng-template pTemplate>
          <div class="flex w-full h-full">
            <div class="w-1/2 h-full mt-1 mb-2">
              <prox-ag-grid [gridOptions]="tagGridOptions" [rowData]="tags"></prox-ag-grid>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div class="flex flex-col w-full h-full">
            <div class="qb-child-actions">
              <p-button [disabled]="!selectedTag || isReadOnly()" (onClick)="onTmapAdd()" size="small"
                label="Assign Product Types" icon="pi pi-plus"></p-button>
            </div>
            <div class="flex w-full h-full">
              <div class="w-full h-full mt-1 mb-2">
                <prox-ag-grid [gridOptions]="tmapGridOptions" [rowData]="tmaps">
                </prox-ag-grid>
              </div>
            </div>
          </div>
        </ng-template>
      </p-splitter>
    </p-tabPanel>
    <p-tabPanel header="Product Types => Tags">
      <div class="flex flex-col w-full h-full">
        <div class="flex flex-row mb-4 align-items-center mt-3">
          <p-button styleClass="mr-6" [disabled]="isReadOnly() || (pptSelectedCount < 2)" (onClick)="onMultiTags()"
            label="Apply Tags to {{pptSelectedCount}} Product Types" size="small"></p-button>
          <div class="mt-3">
            <p-checkbox [disabled]="isReadOnly()" [(ngModel)]="shouldShowOnlyProductsWithNoTags"
              (onChange)="refreshPpts()" [binary]="true" name="shouldShowOnlyProductsWithNoTags"
              inputId="shouldShowOnlyProductsWithNoTags"></p-checkbox>
            <label for="shouldShowOnlyProductsWithNoTags" class="ml-2">Show Only Products With No Tags</label>
          </div>
        </div>
        <div class="flex w-full h-full">
          <div class="w-full h-full py-2">
            <prox-ag-grid [gridOptions]="pptGridOptions" [rowData]="ppts"></prox-ag-grid>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" [isReadOnly]="isReadOnly()" (undo)="onUndo()" (save)="onSave()"
    (cancel)="onCancel()"></prox-save-cancel>
</ng-template>